export default {
  //POSA_AUTHENTICATION
  GET_ACCESS_TOKEN: "/auth/refresh",
  //ECOMM_AUTHENTICATION
  ECOMM_AUTHENTICATE: "/oauth2/token/?",
  GET_LOGGED_IN_USER_INFO: "bookit/retailer-profile/",
  GET_RETAILER_INFO: "bookit/retailer/",

  //ECOMM_CUSTOMER_LIST
  GET_CUSTOMER_LIST: "customer/list/",
  //POS_CUSTOMER_AUTO_COMPLETE
  GET_CUSTOMER_AUTO_COMPLETE: "customer/auto-complete",
  // ECOMM_ADDRESS_LIST
  GET_CUSTOMER_ADDRESS_LIST: "/address/list/",

 UPDATE_CHECKBOX : "enableSlots/createOrUpdate"  ,
 GET_CHECKBOX_VALUE: "enableSlots",

  //ETAIL_STORES
  GET_STORES_LIST: "etail-plus/stores/",
  ADD_TIME_ZONE: "bookit/set-timezone/",

  //SERVICE_TYPES
  GET_SERVICE_TYPES_LIST: "service-types",
  ADD_NEW_SERVICE_TYPE: "service-types/new",
  EDIT_SERVICE_TYPE: "service-types/update/",
  DELETE_SERVICE_TYPE: "service-types/",

  //SHAMPOO
  GET_SHAMPOO_LIST: "pet-shampoo",
  ADD_SHAMPOO: "pet-shampoo/new",
  EDIT_SHAMPOO: "pet-shampoo/update/",
  BULK_UPDATE_SHAMPOO: "pet-shampoo/update/bulk",
  DELETE_SHAMPOO: "pet-shampoo/",

  //COLOGNE
  GET_COLOGNE_LIST: "pet-cologne",
  ADD_COLOGNE: "pet-cologne/new",
  EDIT_COLOGNE: "pet-cologne/update/",
  BULK_UPDATE_COLOGNE: "pet-cologne/update/bulk",
  DELETE_COLOGNE: "pet-cologne/",
  GET_ACTIVE_COLOGNE_LIST: "pet-cologne/getAllByActive",

  //FEEDING_INFO
  GET_FEEDING_INFO: "/feeding-information",
  UPDATE_FEEDING_INFO: "/feeding-information/update",

  //WAIVER_OF_LIABILITY_CONFIGURATION_INFO
  GET_WAIVER_OF_LIABILITY_CONFIGURATION_INFO: "/waiver-of-liability-information",
  UPDATE_WAIVER_OF_LIABILITY_CONFIGURATION_INFO: "/waiver-of-liability-information/update",

  //ATTENDANTS
  GET_ATTENDANT_LIST: "attendant/attendantsByPagination",
  ADD_NEW_ATTENDANT: "attendant/new",
  GET_ATTENDANT_DETAILS: "attendant/",
  GET_ALL_ATENDANTS: "attendant/",
  EDIT_ATTENDANT_DETAILS: "attendant/update/",

  //BOOK_AAPOINTMENT
  GET_ACTIVE_SERVICE_TYPES_LIST: "service-types/getAllByActive",
  GET_SERVICE_NAMES_BY_ID: "service/serviceType/",
  GET_ACTIVE_SHAMPOO_LIST: "pet-shampoo/getAllByActive",
  CREATE_APPOINTMENT: "appointment/create",
  EDIT_APPOINTMENT: "appointment/update",
  EDIT_SLOT: "timeslot/update",
  UPDATE_APPOINTMENT: "appointment/reopened",

  //ADD_ON_SERVICES
  GET_ADD_ON_SERVICES_LIST: "add-on-service/",
  GET_ACTIVE_ADD_ON_SERVICES_LIST: "add-on-service/getAllByActive",
  ADD_NEW_ADD_ON_SERVICE: "add-on-service/new",
  UPDATE_ADD_ON_SERVICE: "add-on-service/update/",
  DELETE_ADD_ON_SERVICE: "add-on-service/",

  //PET_SIZES
  GET_PET_SIZES: "general-pet-size/",
  EDIT_PET_SIZE: "general-pet-size/update/bulk",

  //EXTENDED_BEHAVIOR_INFORMATION
  GET_EXTENDED_BEHAVIOR_INFORMATION: "extended-behaviour-information",
  UPDATE_EXTENDED_BEHAVIOR_INFORMATION: "extended-behaviour-information/update",

  //PET_TYPES
  GET_ACTIVE_PET_TYPES: "pet-types/",
  GET_PET_TYPES: "pet-types/",
  ADD_NEW_PET_TYPE: "pet-types/new",
  GET_PET_DETAILS: "pet-types/getActiveDetails/",

  EDIT_PET_TYPE: "pet-types/update/",

  //VENUE
  GET_VENUE_LIST: "/venue/venuesByPagination",
  DELETE_VENUE_LIST: "venue/",
  DELETE_BLOCKED_DATE_LIST: "block_dates/",
  ADD_VENUE: "venue/new",
  GET_ALL_VENUES: "venue/",
  EDIT_VENUE: "venue/update/",
  VENUE_BY_ID: "venue/",

  //SCHEDULE
  GET_SCHEDULE_LIST: "appointment/getAppointmentsOfMonthView",
  GET_SCHEDULE_LIST_FOR_DAY: "block_dates/fetchBlockTimes",
  GET_SCHEDULE_LIST_WEEK: "appointment",
  GET_SLOTES_LIST: "timeslot/timeSlotsOfAMonth",
  // GET_SLOTES_LIST: "timeslot",
  GET_SLOTES_LIST_WEEK: "timeslot",
  GET_BLOCKED_SCHEDULE_LIST: "block_dates?",
  GET_SCHEDULES_ON_DATE_LIST: "appointment/onDate/",
  GET_SLOTES_ON_DATE_LIST: "timeslot/onDate/",
  GET_BLOCK_SCHEDULES_ON_DATE_LIST: "/block_dates/create-with-multipletime-range",
  GET_BLOCK_SCHEDULES_ON_DATE_LIST_RECURRING: "/block_dates/create-recurring",
  GET_APPOINTMENT_DETAILS_BY_ID: "appointment/",
  GET_SLOT_DETAILS_BY_ID: "timeslot/getSlotById",

  GET_AVAILABLE_TIME_SLOTS: "/appointment/available",

  GET_AVAILABLE_TIME_SLOTS_MANUAL: "/timeslot/fetchSlotsByAttendant",

  //payment
  GET_PAYMENT: "appointment/makeReadyToPay/",

  //appointments list
  GET_APPOINTMENTS_LIST: "appointment/appointments",
  APPOINTMENT_IMPORT_TEMPLATE: "appointment-import/template",
  APPOINTMENT_IMPORT_UPLOAD: "appointment-import/upload",

  //SERVICE
  CREATE_NEW_SERVICE: "service/new",
  GET_SERVICES_LIST_BY_PAGINATION: "service/serviceByPagination/",
  EDIT_SERVICE: "service/update",
  SERVICE: "service/",
  START_SERVICE: "/start",
  SEND_EMAIL_EXPORT:"appointment/manualResendAppointmentExport",
  END_SERVICE: "/end",
  SERVICE_INFO_BY_ID: "service/",
  GET_ACTIVE_SERVICES: "service/getAllByActive",
  GET_SERVICE_AMOUNT: "appointment/calculateServiceAmount",
  ADD_NOTES: "/addNote",
  LIST_NOTES: "/listNotes",
  LIST_NOTES_BY_PET_ID: "list-notes-by-pet-id/",
  NOTES: "/notes",

  //CUSTOMER_PET_LIST
  GET_ALL_CUSTOMER_PET_LIST: "pet/",
  GET_PET_LIST_BY_CUSTOMER: "pet/petsByCustomer/",

  CREATE_NEW_CUSTOMER:
    "/retailer/customers/create/",

  GET_CUSTOMER_PET_LIST: "pet/petsByPagination",
  GET_CUSTOMER_PET_LIST_BASEDONSERVICE: "pet-types/getPetList",

  //CUSTOMER_PET_ADD
  CUSTOMER_PET_ADD: "pet/new",
  CUSTOMER_PET_UPDATE: "pet/update/",

  //GET_SERVICE_HISTORY_DETAILS
  GET_SERVICE_HISTORY_DETAILS: "service/detailedHistory?appointmentId=",

  //GET_SERVICE_HISTORY_NOTES
  GET_SERVICE_HISTORY_NOTES: "service/detailedNote?appointmentId=",

  //SERVICE_HISTORY
  SERVICE_HISTORY: "service/appointmentHistory",

  CANCEL_APPOINTMENT: "/cancel",

  APPROVE_APPOINTMENT: "/changeServiceStatus",

  CANCEL_SLOT: "timeslot/deleteSlotsById",

  CONFIG_DOC: 'document/',

  ADD_NEW_SLOT: 'timeslot/generate-slots',

  SEND_EMAIL: 'pet/sendEmail',

  ADD_TO_WAITLIST:'waitList/addToWaitList',

  WAITLISTED_CUSTOMERS : 'waitList/timeSlot',

  UPDATE_WAITLIST : '/waitList/bulkUpdate',
  
  FETCH_WAITLIST : '/waitList/all'

};